<div class="main-frame">
  <div id="main-wrapper">
    <div class="page-wrapper">
      <header id="dragbar" class="window-bar" (dblclick)="toggleWindowMaximize()">
        <div class="window-brand" aria-label="W3Booster">
          <span class="window-brand-name w3booster-wordmark"><b class="w3booster-wordmark-w3">W3</b><em class="w3booster-wordmark-booster">Booster</em></span>
          <small>v{{version}}</small>
        </div>
        <nav class="window-links" aria-label="Help and account">
          <a class="window-discord-support" target="_blank" rel="noopener" href="https://discord.gg/JwDFqp6">Need support? Join <span class="fab fa-discord"></span> Discord</a>
        </nav>
        <div class="window-controls" aria-label="Window controls">
          <button type="button" (click)="minimizeWindow(); $event.stopPropagation()" aria-label="Minimize">
            <span class="fa fa-window-minimize"></span>
          </button>
          <button type="button" (click)="toggleWindowMaximize(); $event.stopPropagation()"
            [attr.aria-label]="(isMaximized || isFullScreen) ? 'Restore window' : 'Maximize window'">
            <span [class]="(isMaximized || isFullScreen) ? 'fa fa-window-restore' : 'far fa-window-maximize'"></span>
          </button>
          <button type="button" class="window-close" (click)="closeWindow(); $event.stopPropagation()" aria-label="Close">
            <span class="fa fa-times"></span>
          </button>
        </div>
      </header>
      <div class="container-fluid" id="content-area">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
